import React from 'react';

import { Header } from 'components';
import { PublicRoute } from 'utils';
import { RegisterForm } from '../../components';

export const Register = () => {
  PublicRoute();

  return (
    <>
      <Header />
      <RegisterForm />
    </>
  );
};
